var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect } from 'react';
import { Modal, Table, Button } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import api from '@/api';
const SelectBonusModal = ({ visible, onOk, onCancel, initialSelectedItem, }) => {
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [bonusList, setBonusList] = useState([]); //列表数据
    //弹框打开的时候调用加分列表接口
    useEffect(() => {
        if (visible) {
            getBonusOptions();
        }
    }, [visible]);
    //获取加分列表
    const getBonusOptions = () => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield api.CoachCardApi.getBonusOptions();
        if (res.data.code === 200) {
            setBonusList(res.data.data);
        }
    });
    useEffect(() => {
        if (initialSelectedItem) {
            setSelectedRowKeys(initialSelectedItem.code ? [initialSelectedItem.code] : []);
            setSelectedRow(initialSelectedItem);
        }
        else {
            setSelectedRowKeys([]);
            setSelectedRow(null);
        }
    }, [initialSelectedItem, visible]);
    const columns = [
        {
            title: 'Code',
            dataIndex: 'categoryCode',
            key: 'categoryCode',
        },
        {
            title: 'Level',
            dataIndex: 'level',
            key: 'level',
        },
        {
            title: 'DD',
            dataIndex: 'dd',
            key: 'dd',
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
    ];
    const rowSelection = {
        type: 'radio',
        selectedRowKeys,
        onChange: (keys, selectedRows) => {
            setSelectedRowKeys(keys);
            setSelectedRow(selectedRows.length > 0 ? selectedRows[0] : null);
        },
    };
    const handleOk = () => {
        onOk(selectedRow);
    };
    const handleCancel = () => {
        onCancel();
    };
    return (<Modal title="Select Bonus" visible={visible} onOk={handleOk} onCancel={handleCancel} width="50%" bodyStyle={{ minHeight: '40vh', maxHeight: '60vh', overflowY: 'auto' }} footer={[
            <Button key="cancel" onClick={handleCancel} icon={<CloseOutlined />}>
          Cancel
        </Button>,
            <Button key="ok" type="primary" onClick={handleOk} icon={<CheckOutlined />}>
          OK
        </Button>,
        ]}>
      <Table rowKey={(record) => record.categoryCode + record.dd} rowSelection={rowSelection} columns={columns} dataSource={bonusList} pagination={false} bordered size="small" onRow={(record) => {
            return {
                onClick: () => {
                    setSelectedRowKeys([record.categoryCode + record.dd]);
                    setSelectedRow(record);
                },
            };
        }}/>
    </Modal>);
};
export default SelectBonusModal;
